module.exports = __webpack_public_path__ + "static/media/17.0d61da8f.jpg";